import React, { useEffect } from 'react';
import { Toaster } from 'sonner';
import './App.css';

import { useAuthStore } from './store';
import AdminPage from './AdminPage';

function AuthChecker({ children }) {
  const { checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return children;
}

function App() {
  return (
    <AuthChecker>
      <div className="h-full w-full bg-background overflow-hidden">
        <AdminPage />
        <Toaster 
          position="bottom-center" 
          toastOptions={{
            style: {
              background: 'rgba(0, 0, 0, 0.85)',
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '9999px',
            }
          }}
        />
      </div>
    </AuthChecker>
  );
}

export default App;
